import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import SEOContent from './components/SEOContent';
import ArticlesSection from './components/ArticlesSection';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <CTASection />
      <ArticlesSection />
      <SEOContent />
      <Testimonials />
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'CSSBuySpreadsheet',
            url: siteUrl,
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png',
            description: 'O guia mais completo de spreadsheets CSSBuy atualizado diariamente com produtos da China.',
            sameAs: ['https://kaspreadsheet.com'],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'CSSBuySpreadsheet',
            url: siteUrl,
            description: 'Guia completo de spreadsheets CSSBuy com atualizações diárias de produtos da China.',
            inLanguage: 'pt-BR',
          }),
        }}
      />
    </main>
  );
}